import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
} from '@angular/core';

export interface Frame {
  name: string;
  path?: string;
  promo?: boolean;
}

@Component({
  selector: 'app-frame-slider',
  templateUrl: './frame-slider.component.html',
  styleUrls: ['./frame-slider.component.scss'],
})
export class FrameSliderComponent {
  @Input() framesPaths: Frame[] = [];
  @Input() recorder: any;
  @Input() title?: string;
  //@Input() filters: any[] = [];          // ✅ support for filters
  @Input() filterItems: any[] = []; // ✅ legacy structure support
  @Input() filterMode = false;           // ✅ toggle mode

  @Output() frameSelected = new EventEmitter<string>();
  //@Output() filterSelected = new EventEmitter<{ index: number; name: string }>();
  @Output() filterSelected = new EventEmitter<{ index: number; name: string; value: string }>();

  //@ViewChild('framesWrapper') framesWrapper!: ElementRef<HTMLDivElement>;
  @ViewChild('framesWrapper', { static: false }) framesWrapper!: ElementRef<HTMLDivElement>;

   filters: any[] = [];
   currentIndex = 0;
   slidesPerPage = 5;


  constructor(private cdr: ChangeDetectorRef){}

  ngOnInit() {
    if (this.filterMode) {
      this.initializeFilters();
    }
  }

  private initializeFilters() {
    // Use provided filters directly (new format)
    if (this.filterItems?.length) {
      this.filters = [...this.filterItems];
    }

    // Add "None" option if missing
    const hasNone = this.filters.some(f => f.name.toLowerCase() === 'none');
    if (!hasNone) {
      this.filters.unshift({
        name: 'None',
        value: 'none',
        preview: 'none',
        selected: '#292C3E'
      });
    }

    // Apply saved selected state
    const savedIndex = this.recorder?.selectedFilterIndex ?? 0;
    this.filters.forEach((f, i) => f.selected = i === savedIndex ? '#4FEAAE' : '#292C3E');
    this.cdr.detectChanges();

  }

  onFrameClick(frame: Frame) {
    this.frameSelected.emit(frame.name);
  }

  // onImgError(event: Event) {
  //   (event.target as HTMLImageElement).src =
  //     'assets/images/frames/placeholder.png';
  // }

  scrollFiltersLeft() {
    if (!this.filterMode) return; // only works for filters
    const el = this.framesWrapper.nativeElement;
    const filterItem = el.querySelector('.filterIcons');
    if (!filterItem) return;

    const itemWidth = filterItem.clientWidth || 100;
    const computedStyle = window.getComputedStyle(filterItem);
    const gap = parseInt(computedStyle.marginRight || '30', 10) || 30;

    const scrollAmount = (itemWidth + gap) * 5; // scroll 5 filters at a time
    el.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
  }

  scrollFiltersRight() {
    if (!this.filterMode) return; // only works for filters
    const el = this.framesWrapper.nativeElement;
    const filterItem = el.querySelector('.filterIcons');
    if (!filterItem) return;

    const itemWidth = filterItem.clientWidth || 100;
    const computedStyle = window.getComputedStyle(filterItem);
    const gap = parseInt(computedStyle.marginRight || '30', 10) || 30;

    const scrollAmount = (itemWidth + gap) * 5; // scroll 5 filters at a time
    el.scrollBy({ left: scrollAmount, behavior: 'smooth' });
  }


  scrollLeft() {
    const el = this.framesWrapper.nativeElement;
    const frameWidth = el.querySelector('.filterIcons')?.clientWidth || 100;
    const scrollAmount = (frameWidth + 30) * 5; // ✅ match new gap (30px)
    el.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
  }

  scrollRight() {
    const el = this.framesWrapper.nativeElement;
    const frameWidth = el.querySelector('.filterIcons')?.clientWidth || 100;
    const scrollAmount = (frameWidth + 30) * 5; // ✅ match new gap (30px)
    el.scrollBy({ left: scrollAmount, behavior: 'smooth' });
  }

  // ✅ handle both frames and filters
  selectItem(item: any, index?: number) {

    if (this.filterMode) {
      this.filters.forEach(f => f.selected = '#292C3E');
      const selectedIndex = index ?? 0;
      this.filters[selectedIndex].selected = '#4FEAAE';

      // Save selected state
      this.recorder.selectedFilterIndex = selectedIndex;
      this.recorder.selectedFilter = item.value;

      // ✅ Emit clean event
      this.filterSelected.emit({ index: selectedIndex, name: item.name, value: item.value });
      console.log('📤 Emitting filterSelected:', { index: selectedIndex, name: item.name, value: item.value });
    } else {
      this.frameSelected.emit(item.name);
    }

    this.cdr.detectChanges();

  }
}
